import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { CCTV_POPUP_RESERVED_SEGMENTS } from '../monitoring/cctvPopupRoutes';
import {
  poolSiteMonitoringState,
  poolSiteShortPath,
} from '../../utils/poolSitePaths';

/** /POOL001/monitoring 북마크 → 주소창 /POOL001 + 모니터링 화면(별도 pool-monitoring URL 없음) */
const PoolShortMonitoringRoute: React.FC = () => {
  const { poolCode } = useParams<{ poolCode: string }>();

  if (!poolCode) {
    return <Navigate to="/central-control" replace />;
  }

  const decoded = decodeURIComponent(poolCode);
  if (CCTV_POPUP_RESERVED_SEGMENTS.has(decoded.toLowerCase())) {
    return <Navigate to="/central-control" replace />;
  }

  return (
    <Navigate
      to={poolSiteShortPath(decoded)}
      replace
      state={poolSiteMonitoringState()}
    />
  );
};

export default PoolShortMonitoringRoute;
